import React from 'react';
import QrReader from 'react-qr-reader';
import KeyCodes from '../../utils/KeyCodes';

class OrdersSearch extends React.Component {

    constructor(props) {
        super(props);
        this.handleQrScan = this.handleQrScan.bind(this);
    }

    componentDidMount() {
        $('#cpfInput').mask('000.000.000-00');
    }

    componentWillUpdate() {
        $('#cpfInput').unmask();
    }

    componentDidUpdate() {
        $('#cpfInput').mask('000.000.000-00');
        if (!this.props.selectedOrder) {
            $('#cpfInput').focus();
        }
    }

    componentWillUnmount() {
        $('#cpfInput').unmask();
    }

    handleQrError(e) {
        console.error(e);
    }

    selectOrder(cpf) {
        const orders = this.props.orders;
        const order = orders.find(o => o.cpf === cpf);
        if (order) {
            this.props.onSelectOrder(order.id);
        } else {
            this.props.onShowDialog("Erro!", "Não foi encontrado nenhum pedido associado ao cliente.");
        }
    }

    handleQrScan(data) {
        if (data && this.props[this.props.idClienteName] !== data) {
            const beepUrl = require('../../../resources/audio/scanner_beep.mp3');
            const snd = new Audio(beepUrl);
            snd.play();
            this.props.onUpdateValue(this.props.idClienteName, data);
            this.props.onRefresh()
                .then(() => this.selectOrder(data));
        }
    }

    render() {
        const cpf = this.props[this.props.cpfClienteName];
        const qrPreviewStyle = {
            width: 200
        };

        const onCpfChanged = (e) => {
            const enteredCpf = $(e.target).cleanVal();
            this.props.onUpdateValue(this.props.cpfClienteName, enteredCpf);
            if (enteredCpf.length === 1) {
                this.props.onRefresh();
            }
            if (enteredCpf.length === 11) {
                this.props.onRefresh()
                    .then(() => this.selectOrder(enteredCpf));
            }
        };
        const onCpfKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ESCAPE)
                this.props.onUpdateValue(this.props.cpfClienteName, '');
        };
        const onTogglePreview = () => {
            this.props.onUpdateValue(this.props.showQrPreviewName, !this.props[this.props.showQrPreviewName]);
        };

        const qrPreview = (
          <div className="col-sm-12  form-group">
            <div style={{"width": qrPreviewStyle.width}} className="center-block">
                <QrReader delay={100} onError={this.handleQrError} onScan={this.handleQrScan} style={qrPreviewStyle}/>
            </div>
          </div>
        );

        return (
            <div>
                <div className="form-group">
                    <label htmlFor="cpfInput">CPF</label>
                    <div className="input-group m-t-10">
                        <input type="text" id="cpfInput" className="form-control"
                            maxLength="14" placeholder="000.000.000-00" autoFocus={true}
                            onChange={onCpfChanged} onKeyDown={onCpfKeyDown} value={cpf} />
                        <span className="input-group-btn">
                            <button type="button" className="btn btn-effect-ripple btn-primary" onClick={onTogglePreview}>
                                <i className="glyphicon glyphicon-qrcode" />
                            </button>
                        </span>
                    </div>
                </div>
                {this.props[this.props.showQrPreviewName] && qrPreview}
            </div>
        );
    }
}

export default OrdersSearch;



// WEBPACK FOOTER //
// src/views/controls/OrdersSearch.jsx